






import Vue from 'vue';
import {mapState, mapActions} from 'vuex';
import store from '../store/store';

import CheckInfo from '@/components/CheckInfo.vue';
Vue.component('CheckInfo-component', CheckInfo);

export default Vue.extend({
  name: 'myCheckInfo',
  data() {
    return {
    };
  },
  computed: mapState({
    userInfo: (state: any) => store.getters.getUserInfo
  }),
  methods: {
  },
  destroyed() {
    // this.$store.dispatch('setCheckResult', []);
  }
});
